import locale from "@utils/locale"
export const defaultLang = locale.lang.简体中文
export default {
  defaultLang,
}
